import { HashRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from './auth'
import { ALL_ITEMS, podeAcessarPreLicenciado } from './routes'
import BloqueioPreLicenciado from './components/BloqueioPreLicenciado'
import AtualizacaoDisponivel from './components/AtualizacaoDisponivel'
import Layout from './components/Layout'
import { UIHost } from './components/ui'
import Crud from './components/Crud'
import * as cfg from './crudConfigs'
import Placeholder from './pages/Placeholder.jsx'
import Login from './pages/Login.jsx'
import Dashboard from './pages/Dashboard.jsx'
import NovaConexao from './pages/NovaConexao.jsx'
import Pedidos from './pages/Pedidos.jsx'
import MeuLink from './pages/MeuLink.jsx'
import Material from './pages/Material.jsx'
import Flyer from './pages/Flyer.jsx'
import FilaAnalise from './pages/FilaAnalise.jsx'
import FilaConexao from './pages/FilaConexao.jsx'
import MinhasConexoes from './pages/MinhasConexoes.jsx'
import Notificacoes from './pages/Notificacoes.jsx'
import CentralNotificacoes from './pages/CentralNotificacoes.jsx'
import ProtecaoVeicular from './pages/ProtecaoVeicular.jsx'
import PvAdmin from './pages/PvAdmin.jsx'
import Telecom from './pages/Telecom.jsx'
import Rede from './pages/Rede.jsx'
import Comissoes from './pages/Comissoes.jsx'
import ParametrosMLM from './pages/ParametrosMLM.jsx'
import IAConfig from './pages/IAConfig.jsx'
import Faturas from './pages/Faturas.jsx'
import FaturasPainel from './pages/FaturasPainel.jsx'
import FaturasPagas from './pages/FaturasPagas.jsx'
import ImportarFaturas from './pages/ImportarFaturas.jsx'
import Auditoria from './pages/Auditoria.jsx'
import BuscaAdmin from './pages/BuscaAdmin.jsx'
import MeuFinanceiro from './pages/MeuFinanceiro.jsx'
import FinanceiroAdmin from './pages/FinanceiroAdmin.jsx'
import FinanceiroPainelAdmin from './pages/FinanceiroPainelAdmin.jsx'
import IntegracaoAsaas from './pages/IntegracaoAsaas.jsx'
import PainelVendas from './pages/PainelVendas.jsx'
import ClientesRede from './pages/ClientesRede.jsx'
import MinhaRede from './pages/MinhaRede.jsx'
import MinhaConta from './pages/MinhaConta.jsx'
import Suporte from './pages/Suporte.jsx'
import Universidade from './pages/Universidade.jsx'
import Incentivos from './pages/Incentivos.jsx'
import Fundo from './pages/Fundo.jsx'
import GestaoSaques from './pages/GestaoSaques.jsx'
import Parcelamento from './pages/Parcelamento.jsx'
import BI from './pages/BI.jsx'
import TermosAdmin from './pages/TermosAdmin.jsx'
import MeusDocumentos from './pages/MeusDocumentos.jsx'
import SimuladorMotor from './pages/SimuladorMotor.jsx'
import TempoCadastro from './pages/TempoCadastro.jsx'
import Loja from './pages/public/Loja.jsx'
import Aceite from './pages/public/Aceite.jsx'
import Indicacao from './pages/public/Indicacao.jsx'
import Recrutamento from './pages/public/Recrutamento.jsx'
import Pagamento from './pages/public/Pagamento.jsx'
import Simulador from './pages/public/Simulador.jsx'
import PrimeiroAcesso from './pages/PrimeiroAcesso.jsx'
import EsqueciSenha from './pages/EsqueciSenha.jsx'
import RedefinirSenha from './pages/RedefinirSenha.jsx'
import CompletarCadastro from './pages/CompletarCadastro.jsx'
import DashboardApresentacao from './pages/DashboardApresentacao.jsx'
import GeradorParceiro from './pages/GeradorParceiro.jsx'
import Distribuidoras from './pages/Distribuidoras.jsx'
import ExtratoPontos from './pages/ExtratoPontos.jsx'
import NotificacaoTemplates from './pages/NotificacaoTemplates.jsx'
import CampanhaDetalhe from './pages/CampanhaDetalhe.jsx'
import MotorRemuneracao from './pages/MotorRemuneracao.jsx'
import Funcionarios from './pages/Funcionarios.jsx'

function DashboardRouter() {
  const { preLicenciado } = useAuth()
  return preLicenciado ? <DashboardApresentacao /> : <Dashboard />
}

const REAL = {
  '/dashboard': <DashboardRouter />,
  // Cadastro
  '/cadastro/licenciados': <Crud {...cfg.licenciados} />,
  '/cadastro/clientes': <Crud {...cfg.clientes} />,
  '/cadastro/distribuidoras': <Distribuidoras />,
  '/cadastro/parceiros': <Crud {...cfg.parceiros} />,
  '/cadastro/geradoras': <GeradorParceiro />,
  '/cadastro/planos-adesao': <Crud {...cfg.planos} />,
  '/cadastro/produtos': <Crud {...cfg.produtos} />,
  '/cadastro/servicos': <Crud {...cfg.servicos} />,
  '/cadastro/ofertas': <Crud {...cfg.ofertas} />,
  // Registros de Conexão / Vendas
  '/registros/conexao': <NovaConexao />,
  '/registros/pedidos': <Pedidos />,
  '/registros/faturas': <Faturas />,
  '/registros/fila-analise': <FilaAnalise />,
  '/registros/fila-conexao': <FilaConexao />,
  '/registros/minhas-conexoes': <MinhasConexoes />,
  '/notificacoes': <Notificacoes />,
  '/notificacoes/central': <CentralNotificacoes />,
  '/notificacoes/templates': <NotificacaoTemplates />,
  // Proteção Veicular — fluxo da operação oficial (LabelView) dentro do EV
  '/registros/protecao-veicular': <ProtecaoVeicular />,
  '/registros/protecao-veicular/nova': <ProtecaoVeicular novaAoAbrir />,
  '/registros/protecao-veicular/gestao': <PvAdmin />,
  '/registros/telecom': <Telecom />,
  // Financeiro / Faturas (módulo)
  '/financeiro/painel': <FaturasPainel />,
  '/financeiro/faturas-pagas': <FaturasPagas />,
  '/financeiro/importar': <ImportarFaturas />,
  '/financeiro/busca': <BuscaAdmin />,
  '/financeiro/auditoria': <Auditoria />,
  '/financeiro/carteira': <MeuFinanceiro />,
  '/financeiro/tesouraria': <FinanceiroAdmin />,
  '/financeiro/admin': <FinanceiroPainelAdmin />,
  '/financeiro/saques-gestao': <GestaoSaques />,
  '/integracoes/asaas': <IntegracaoAsaas />,
  '/vendas/painel': <PainelVendas />,
  '/clientes': <ClientesRede />,
  // Simulações
  '/simulacoes': <Crud {...cfg.simulacoes} />,
  // Incentivos / Fundo
  '/incentivos': <Incentivos />,
  '/incentivos/:id': <CampanhaDetalhe />,
  '/fundo': <Fundo />,
  // Sistema
  '/sistema/usuarios': <Crud {...cfg.usuarios} />,
  '/sistema/qualificacoes': <Crud {...cfg.qualificacoes} />,
  '/sistema/motor-remuneracao': <MotorRemuneracao />,
  '/funcionarios': <Funcionarios />,
  '/sistema/parametros': <ParametrosMLM />,
  '/sistema/ia': <IAConfig />,
  '/sistema/kits': <Crud {...cfg.kits} />,
  '/sistema/campanhas': <Crud {...cfg.campanhas} />,
  // Rede
  '/indicacao': <MeuLink />,
  '/rede': <MinhaRede />,
  '/rede-classica': <Rede />,
  '/crescimento': <BI />,
  '/sistema/termos': <TermosAdmin />,
  '/sistema/simulador-motor': <SimuladorMotor />,
  '/meus-documentos': <MeusDocumentos />,
  '/meu-link': <MeuLink />,
  // Relatórios
  '/relatorios/extrato': <Comissoes />,
  '/relatorios/pontos': <ExtratoPontos />,
  '/relatorios/comissoes': <Comissoes />,
  '/relatorios/tempo-cadastro': <TempoCadastro />,
  // Material de Apoio
  '/material': <Material />,
  '/universidade': <Universidade />,
  '/flyer': <Flyer />,
  '/suporte': <Suporte />,
  // Integrações
  '/integracoes/pagamento': <Crud {...cfg.meiosPagamento} />,
  '/integracoes/parcelamento': <Parcelamento />,
  // Cadastro complementar obrigatório (após ativação)
  '/completar-cadastro': <CompletarCadastro />,
}

function Guard() {
  const { token } = useAuth()
  if (!token) return <Navigate to="/login" replace />
  return <Layout />
}

// '/meu-link' fora da lista: a página mantém os links de SERVIÇO (Recrutamento/Simulador/
// Indicar Cliente) mesmo com a loja off; o conteúdo de loja é gateado dentro da própria página.
const LOJA_PATHS = ['/registros/pedidos', '/vendas/painel']

// Rotas EXCLUSIVAS de administrador. O backend já exige admin (get_admin_user); este guard evita
// renderizar o painel administrativo para quem digitar a URL direto (defesa em profundidade).
const ADMIN_PATHS = ['/registros/protecao-veicular/gestao', '/financeiro/saques-gestao']

// Bloqueia rotas não permitidas ao PRÉ-LICENCIADO (licença pendente) + Loja desligada — PRD.
function Gated({ path, children }) {
  const { preLicenciado, lojaHabilitada, user } = useAuth()
  if (preLicenciado && !podeAcessarPreLicenciado(path)) return <BloqueioPreLicenciado />
  if (ADMIN_PATHS.includes(path) && user?.perfil !== 'admin') {
    return (
      <div className="max-w-lg mx-auto mt-10 bg-white rounded-2xl border border-neutral-200 shadow-sm p-8 text-center">
        <h2 className="text-lg font-heading font-extrabold text-graphite">Área restrita</h2>
        <p className="text-sm text-gray-600 mt-2">Esta página é exclusiva do administrador.</p>
      </div>
    )
  }
  if (user?.perfil !== 'admin' && !lojaHabilitada && LOJA_PATHS.includes(path)) {
    return (
      <div className="max-w-lg mx-auto mt-10 bg-white rounded-2xl border border-neutral-200 shadow-sm p-8 text-center">
        <h2 className="text-lg font-heading font-extrabold text-graphite">Loja indisponível</h2>
        <p className="text-sm text-gray-600 mt-2">A Loja de produtos físicos está temporariamente indisponível. Fale com o administrador.</p>
      </div>
    )
  }
  return children
}

export default function App() {
  // Rotas únicas (dedupe por path) a partir de todos os menus de perfil.
  const seen = new Set()
  const items = ALL_ITEMS.filter((it) => it.path && (seen.has(it.path) ? false : seen.add(it.path)))

  return (
    <AuthProvider>
      <UIHost />
      <AtualizacaoDisponivel />
      <HashRouter>
        <Routes>
          {/* Públicas */}
          <Route path="/login" element={<Login />} />
          <Route path="/loja/:codigo" element={<Loja />} />
          <Route path="/aceite/:token" element={<Aceite />} />
          <Route path="/indicacao/:codigo" element={<Indicacao />} />
          {/* 3 links separados (doc 20-06): negócio (recrutamento) · loja · cliente-indica-cliente */}
          <Route path="/negocio/:codigo" element={<Recrutamento />} />
          <Route path="/cliente/:codigo" element={<Indicacao />} />
          <Route path="/simulador/:codigo" element={<Simulador />} />
          {/* Checkout transparente (PIX/boleto na tela · cartão via ASAAS) */}
          <Route path="/pagamento-licenca/:ref" element={<Pagamento tipo="licenca" />} />
          <Route path="/pagamento-renovacao/:ref" element={<Pagamento tipo="renovacao" />} />
          <Route path="/pagamento/:codigo" element={<Pagamento tipo="pedido" />} />
          {/* Acesso / recuperação de senha */}
          <Route path="/primeiro-acesso/:token" element={<PrimeiroAcesso />} />
          <Route path="/esqueci-senha" element={<EsqueciSenha />} />
          <Route path="/redefinir-senha/:token" element={<RedefinirSenha />} />

          {/* Protegidas */}
          <Route element={<Guard />}>
            <Route path="/minha-conta" element={<MinhaConta />} />
            {items.map((it) => (
              <Route key={it.path} path={it.path}
                element={<Gated path={it.path}>{REAL[it.path] || <Placeholder title={it.label} />}</Gated>} />
            ))}
          </Route>

          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </HashRouter>
    </AuthProvider>
  )
}
